/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FlashOffIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Flash Off',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.823 20.473 8 36h.9l9.493-10.935-4.57-4.592zM18.26 13.609 26 2H12l-1.286 4.026 7.546 7.583zM23.643 19.019 28 14h-9.351l4.994 5.019zM7.976 14.598 6.25 20h7.102l-5.376-5.402z"
    />
    <rect
      height="43.854"
      rx=".818"
      ry=".818"
      transform="rotate(-45 18 19)"
      width="2.455"
      x="16.773"
      y="-2.926"
    />
  </svg>`;
};
